/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBanPopoverContainer_viewer = {
    readonly moderationScopes: {
        readonly scoped: boolean;
    } | null;
    readonly " $refType": "UserBanPopoverContainer_viewer";
};
export type UserBanPopoverContainer_viewer$data = UserBanPopoverContainer_viewer;
export type UserBanPopoverContainer_viewer$key = {
    readonly " $data"?: UserBanPopoverContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBanPopoverContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBanPopoverContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserModerationScopes",
            "kind": "LinkedField",
            "name": "moderationScopes",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scoped",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '7321e523ba0fa71fc39da287aba448b9';
export default node;
